import { API_URL } from "./api.js";

export async function login(username, password) {
  const res = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Erro no login");
  }
  const data = await res.json();
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
  localStorage.setItem("loginTime", new Date().getTime().toString());
  return data.user;
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("loginTime");
}

export function getUser() {
  const u = localStorage.getItem("user");
  if (!u) return null;
  if (isTokenExpired()) {
    logout();
    return null;
  }
  return JSON.parse(u);
}

export function getToken() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  if (isTokenExpired()) {
    logout();
    return null;
  }
  return token;
}

export function isTokenExpired() {
  const token = localStorage.getItem("token");
  if (!token) return true;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;
    const decoded = JSON.parse(atob(parts[1]));
    const expiresIn = decoded.exp * 1000;
    return Date.now() >= expiresIn;
  } catch (e) {
    return true;
  }
}
